import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import MessageContainer from "../MessageContainer";
import { ReactComponent as DocumentSvg } from "../../../../assets/chat/nda-document.svg";
import Button from "../../Button";
import AppContext from "../../../../AppContext";
import useTendering from "../../../../hooks/useTendering";
import { formatNumber } from "../../../../helpers/common.helper";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
const assetsUri = import.meta.env.ASSETS_URI;

const _prefix = "chat-tendering__selected";

const Selected = ({ tenderingId }) => {
  const { tenderingViewNDA, designStyles } = useContext(AppContext);
  const [detail, setDetail] = useState(undefined);
  const { getById } = useTendering();
  const navigate = useNavigate();

  useEffect(() => {
    if (!tenderingId) return;

    getById(tenderingId).then((data) => {
      setDetail(data);
    });
  }, [tenderingId]);

  if (!detail) return null;

  return (
    <MessageContainer alignment={"center"}>
      <div className={_prefix}>
        <span className={`${_prefix}__text`}>
          <span className={`${_prefix}__text--bold`}>Congratulation</span>, you
          are selected to submit quotations and download the document of this
          project on detail page of the project. Thank you for your effort.
          Please send your Quotation and Master Schedule
        </span>
        <div
          className={`${_prefix}__detail`}
          onClick={() => {
            navigate(`/tenderings/${tenderingId}`);
          }}
        >
          <img
            className={`${_prefix}__detail__cover`}
            src={`${assetsUri}/${
              detail.images.cover.cropped ?? detail.images.cover.original
            }`}
          />
          <div className={`${_prefix}__detail__info`}>
            <span style={{ fontWeight: 500, fontSize: 14 }}>{detail.name}</span>
            <span>
              {detail.area.size} {detail.area.unit}
            </span>
            <span>
              {designStyles.works.find((w) => w.value === detail.work)?.name}
            </span>
            {detail.budget ? (
              <span>{formatNumber(detail.budget, "THB")}</span>
            ) : (
              <></>
            )}
            <span>
              Ends on {format(new Date(detail.period.end), "dd MMM yyyy")}
            </span>
          </div>
        </div>
      </div>
    </MessageContainer>
  );
};

Selected.propTypes = {};

export default Selected;
